// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2iHqX","text":"SelectPayment_text__1hR-7","title":"SelectPayment_title__3mtbm","btn":"SelectPayment_btn__qejdG"};